import { decodeOptionalOneOf, encodeOneOf, safePage, safeSort, safeText } from '../../../../domain';
import { RestrictedKeys } from '../restricted.key';
import { Places } from '../../../route-consts';
import { SORT_FIELDS } from './company-table';
/** Prefixo dos nomes deste arquivo na intencao - unico na aplicacao (ver `url-codes.test.ts`). */
const PREFIX = 'cp';
/** Os parametros deste place: vao para o endereco. */
const P = {
    // `ramo`, `contato-email` e `contato-fone` sao ADICAO do porte - filtros que a
    // referencia nao tem, reintroduzidos como incremento consciente.
    Cnpj: `${PREFIX}a`,
    RazaoSocial: `${PREFIX}b`,
    NomeFantasia: `${PREFIX}c`,
    RamoAtividade: `${PREFIX}d`,
    ContactEmail: `${PREFIX}e`,
    ContactPhone: `${PREFIX}f`,
    ContactName: `${PREFIX}g`,
    Status: `${PREFIX}h`,
    CompanySort: `${PREFIX}i`,
    CompanyPage: `${PREFIX}j`,
    /** Qual empresa o dialogo esta tratando. */
    CompanyTarget: `${PREFIX}k`
};
/** Os atributos deste place: viajam na intencao, mas nao vao para o endereco. */
const A = {
    /** O presenter da lista de empresas, para os dialogos pedirem recarga a ele. */
    companies_owner: `${PREFIX}l`
};
/** O codigo de cada situacao no endereco. Ver `CodeTable` em `domain`. */
export const COMPANY_STATUS_CODES = {
    '0': 'active',
    '1': 'blocked'
};
/**
 * Os oito filtros da lista de empresas.
 *
 * Todos eram campos de um `react-hook-form` no painel antigo, filtrando no cliente
 * e sem deixar rastro no endereco.
 */
export class CompaniesKeys extends RestrictedKeys {
    get place() {
        return Places.companies;
    }
    get cnpj() {
        return safeText(this._intent.getParameterAsString(P.Cnpj));
    }
    set cnpj(value) {
        this._intent.setParameter(P.Cnpj, value ? value : undefined);
    }
    get razaoSocial() {
        return safeText(this._intent.getParameterAsString(P.RazaoSocial));
    }
    set razaoSocial(value) {
        this._intent.setParameter(P.RazaoSocial, value ? value : undefined);
    }
    get nomeFantasia() {
        return safeText(this._intent.getParameterAsString(P.NomeFantasia));
    }
    set nomeFantasia(value) {
        this._intent.setParameter(P.NomeFantasia, value ? value : undefined);
    }
    /**
     * Ramo de atividade, e-mail e telefone do contato.
     *
     * ADICAO do porte: a referencia nao filtra por eles. Entram no endereco como
     * qualquer outro filtro, entao um link com eles abre a lista filtrada.
     */
    get ramoAtividade() {
        return safeText(this._intent.getParameterAsString(P.RamoAtividade));
    }
    set ramoAtividade(value) {
        this._intent.setParameter(P.RamoAtividade, value ? value : undefined);
    }
    get contactEmail() {
        return safeText(this._intent.getParameterAsString(P.ContactEmail));
    }
    set contactEmail(value) {
        this._intent.setParameter(P.ContactEmail, value ? value : undefined);
    }
    get contactPhone() {
        return safeText(this._intent.getParameterAsString(P.ContactPhone));
    }
    set contactPhone(value) {
        this._intent.setParameter(P.ContactPhone, value ? value : undefined);
    }
    get contactName() {
        return safeText(this._intent.getParameterAsString(P.ContactName));
    }
    set contactName(value) {
        this._intent.setParameter(P.ContactName, value ? value : undefined);
    }
    get status() {
        return decodeOptionalOneOf(this._intent.getParameterAsString(P.Status), COMPANY_STATUS_CODES);
    }
    set status(value) {
        this._intent.setParameter(P.Status, encodeOneOf(value, COMPANY_STATUS_CODES));
    }
    // :: ordenacao
    get sort() {
        return safeSort(this._intent.getParameterAsString(P.CompanySort), SORT_FIELDS);
    }
    set sort(value) {
        this._intent.setParameter(P.CompanySort, value ? value : undefined);
    }
    // :: pagina
    get page() {
        return safePage(this._intent.getParameterAsNumber(P.CompanyPage));
    }
    set page(value) {
        this._intent.setParameter(P.CompanyPage, value > 1 ? value : undefined);
    }
    // :: qual empresa um dialogo trata
    get target() {
        return this._intent.getParameterAsNumber(P.CompanyTarget) ?? undefined;
    }
    set target(value) {
        this._intent.setParameter(P.CompanyTarget, value);
    }
    // :: list
    /**
     * O presenter da lista de empresas.
     *
     * Chamado `list` e nao `owner` de proposito: `RestrictedKeys.owner` ja existe e
     * e o presenter do HUB. Dois conceitos diferentes com o mesmo nome na mesma
     * cadeia de heranca dariam um erro de tipo no melhor caso, e uma confusao
     * silenciosa no pior.
     *
     * Atributo, entao nunca chega a URL. E como um dialogo pede a recarga depois de
     * salvar: quem mudou o dado avisa quem o mostra. Escrito pela
     * `CompaniesPresenter` na descida - o framework caminha da raiz, entao quando o
     * dialogo le isto, a lista que o contem ja rodou.
     */
    get list() {
        return this._intent.attributes.get(A.companies_owner);
    }
    set list(value) {
        this._intent.attributes.set(A.companies_owner, value);
    }
}
//# sourceMappingURL=companies.key.js.map